<div mat-dialog-title class="!text-base">{{title}}</div>
<div mat-dialog-content class="py-0">
    <form [formGroup]="myForm" class="grid gap-y-2">
        <mat-form-field class="w-full">
            <mat-label>Representante</mat-label>
            <mat-select disableOptionCentering (selectionChange)="newPerson()" formControlName="persona_id" required>
                <mat-option>
                    <ngx-mat-select-search formControlName="filter" placeholderLabel="Buscar..."
                        noEntriesFoundLabel="'Sin Resultados'"></ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="-1">Agregar Nuevo</mat-option>
                <mat-option *ngFor="let p of personas| search: myForm.get('filter').value:['completeName']"
                    [value]="p.id">{{p.nombres}} {{p.apellidos}}</mat-option>
            </mat-select>
            <mat-error>
                Completa este campo.
            </mat-error>
        </mat-form-field>
        <div class="w-full flex gap-2">
            <mat-form-field class="w-full">
                <mat-label>Cargos</mat-label>
                <mat-select disableOptionCentering multiple formControlName="cargo" placeholder="Seleccione">
                    <mat-option>
                        <ngx-mat-select-search formControlName="filterC" placeholderLabel="Buscar..."
                            noEntriesFoundLabel="'Sin Resultados'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let cargo of cargos| search: myForm.get('filterC').value:['descripcion']"
                        [value]="cargo.id">{{cargo.descripcion}}</mat-option>
                </mat-select>
            </mat-form-field>
            <button mat-mini-fab type="button" matTooltip="Crear cargo" color="primary"
                style="border-radius: 15%; box-shadow: none;" class="my-2" (click)="addCargo()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </form>
</div>

<div mat-dialog-actions align="end" class="!px-6">
    <button mat-stroked-button color="primary" class="me-4" mat-dialog-close type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="myForm.invalid" [loading]="loading"
        label="Guardar"></adp-button-icon>
</div>
